"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _react = _interopRequireDefault(require("react"));

var _ComponentResolver = _interopRequireDefault(require("./ComponentResolver"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Connector =
/*#__PURE__*/
function () {
  function Connector(historyManager, routeMatcher) {
    var componentResolver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, Connector);

    this.stream = null;
    this.historyManager = historyManager;
    this.routeMatcher = routeMatcher;
    this.componentResolver = componentResolver;

    this.onStateChange = function () {};
  }

  _createClass(Connector, [{
    key: "newInitializedInstance",
    value: function newInitializedInstance(history) {
      var connector = new Connector(this.historyManager, this.routeMatcher, new _ComponentResolver.default());
      connector.init(history);
      return connector;
    }
  }, {
    key: "init",
    value: function init(history) {
      this.initHistory(history);
      this.initRouteMatcher();
      this.initStream();
      return this;
    }
  }, {
    key: "initHistory",
    value: function initHistory(history) {
      this.historyManager.setHistory(history);
      this.historyManager.setRequestCallback(this.request.bind(this));
      this.historyManager.listen();
    }
  }, {
    key: "initRouteMatcher",
    value: function initRouteMatcher() {
      this.routeMatcher.init();
    }
  }, {
    key: "initStream",
    value: function initStream() {
      var _this = this;

      this.stream = new _rxjs.Subject();
      this.stream.pipe((0, _operators.switchMap)(function (pathname) {
        return _this.routeMatcher.createRenderer(pathname);
      }), (0, _operators.skipWhile)(function (renderer) {
        return renderer === null;
      }), (0, _operators.map)(function (renderer) {
        return renderer.fireInitialPropsWillGet();
      }), (0, _operators.mergeMap)(function (renderer) {
        return renderer.fireGetInitialProps();
      }), (0, _operators.map)(function (renderer) {
        return renderer.fireInitialPropsDidGet();
      })).subscribe(function (renderer) {
        _this.componentResolver.setComponentFromRenderer(renderer);

        _this.onStateChange();
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(onStateChange) {
      this.onStateChange = onStateChange;
    }
  }, {
    key: "request",
    value: function request(pathname) {
      this.stream.next(pathname);
    }
  }]);

  return Connector;
}();

exports.default = Connector;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/Connector.js
// module id = 136
// module chunks = 0